import { toJson } from "../../../erd-editor-schema/dist/parser.js";
import { ActionType } from "./actions.js";
import { clearAction, keepsDictionaries, loadJsonAction } from "./atom.actions.js";
//#region src/engine/modules/editor/history.ts
function toUndoLoad(state, keep) {
	if (!keep) return loadJsonAction({ value: toJson(state) });
	const value = toJson({
		...state,
		doc: {
			...state.doc,
			wordIds: [],
			termIds: []
		},
		collections: {
			...state.collections,
			wordEntities: {},
			termEntities: {}
		}
	});
	return loadJsonAction({
		value,
		keepDictionaries: true
	});
}
var loadJson = (undoActions, { payload }, state) => {
	const keep = keepsDictionaries(payload);
	undoActions.push(clearAction(keep ? { keepDictionaries: true } : void 0), toUndoLoad(state, keep));
};
var clear = (undoActions, { payload }, state) => {
	undoActions.push(toUndoLoad(state, keepsDictionaries(payload)));
};
var editorPushUndoHistoryMap = {
	[ActionType.loadJson]: loadJson,
	[ActionType.clear]: clear
};
//#endregion
export { editorPushUndoHistoryMap };
